import React from "react";

// Chakra imports
import { Flex } from "@chakra-ui/react";
import Logo1 from "../../../assets/img/Embrill-Logo_R.png";


export function SidebarBrand() {
  return (
    <Flex align="center" direction="column" className="logo-container">
      <img src={Logo1} alt="logo" style={{ width: "120px" ,height:'auto' }} />
    </Flex>
  );
}

export default SidebarBrand;
